<template>
  <div class="box-border has-background-white box-h-max h-100-per">
    <div class="mg-b-5 line-title-dh is-flex is-justify-spacebetween">
      <b-tooltip
        label="Move"
        type="is-dark"
        v-if="user.userLevel == 0"
        position="is-bottom"
      >
        <p
          class="is-size-5 has-text-weight-normal pd-y-10 vue-draggable-handle"
        >
          {{ $t("dashboard.mainDashboardPerformanceSupport") }}
        </p>
      </b-tooltip>
      <p
        v-else
        class="is-size-5 has-text-weight-normal pd-y-10 vue-draggable-handle"
      >
        {{ $t("dashboard.mainDashboardPerformanceSupport") }}
      </p>
      <p
        class="pd-y-10 icon-color is-size-5 cr-pointer"
        @click="$emit('openModalInfo', 'pfm-s')"
      >
        <i class="fas fa-question-circle"></i>
      </p>
    </div>
    <div v-if="activitysAll.length !== 0">
      <div class="columns m-h-auto is-flex-wrap">
        <div class="column is-12">
          <p
            class="is-size-2 has-text-weight-normal pd-t-20 has-text-centered th"
          >
            {{ activitysAll.length }}
            {{ $t("dashboard.performanceSupportActivity") }}
          </p>
        </div>
        <div class="column is-6-desktop mg-b-10">
          <div class="columns is-flex m-h-auto is-justify-spacebetween">
            <div class="column is-9 pd-y-5">
              <p class="is-size-6 has-text-weight-semibold">
                {{ $t("dashboard.performanceSupportCategory") }}
              </p>
            </div>
            <div
              class="column is-3 has-text-centered has-text-right-mobile pd-y-5"
            >
              <p class="is-size-6 has-text-weight-semibold">
                {{ $t("dashboard.performanceSupportActivity") }}
              </p>
            </div>
          </div>
        </div>
        <div class="column is-6-desktop mg-b-10 is-hidden-touch">
          <div class="columns is-flex m-h-auto is-justify-spacebetween">
            <div class="column is-9 pd-5">
              <p class="is-size-6 has-text-weight-semibold">
                {{ $t("dashboard.performanceSupportCategory") }}
              </p>
            </div>
            <div
              class="column is-3 has-text-centered has-text-right-mobile pd-5"
            >
              <p class="is-size-6 has-text-weight-semibold">
                {{ $t("dashboard.performanceSupportActivity") }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="columns m-h-auto is-flex-wrap">
        <div
          class="column is-12 is-6-desktop"
          v-for="(item, index) in categories"
          :key="index"
        >
          <div class="columns m-h-auto is-flex-wrap is-flex">
            <div class="column is-9-mobile is-9-tablet is-9 pd-y-5 over-text">
              <p
                class="is-size-6 th"
                :title="$i18n.locale === 'th' ? item.name : item.nameEN"
              >
                {{ $i18n.locale === "th" ? item.name : item.nameEN }}
              </p>
            </div>
            <div
              class="column is-3-mobile is-3-tablet is-3 has-text-centered pd-y-5"
            >
              <p class="is-size-6">{{ getActivityOfCat(item.id) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="has-text-centered th is-size-5 pd-20 is-flex is-align-center is-justify-center h-100-per"
    >
      <p>*** {{ $t("dashboard.notfound") }} ***</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["useBy", "activitysAllStartup"],
  computed: {
    activitysAll() {
      if (this.useBy === "startup") {
        return this.$store.state.activitysAll;
      } else {
        return typeof this.activitysAllStartup !== "undefined"
          ? this.activitysAllStartup
          : [];
      }
    },
    user() {
      return this.$store.state.user;
    },
    categories() {
      return this.$store.state.categories;
    },
  },
  methods: {
    getActivityOfCat(id) {
      let res = this.activitysAll.filter((item) => item.categoryId === id);
      return res.length;
    },
  },
};
</script>